export default __webpack_public_path__ + "static/media/noTaskSchedule.80912456.svg";